import React from 'react';
import { Modal } from 'semantic-ui-react';
import Button from '../../../components/Button';
import InputBox from '../../../components/InputBox';
import { toast } from 'react-toastify';

const BulkJobUploadModal = ({ show, onClose, onSubmit }) => {
  const [formData, setFormData] = React.useState({
    recruiterId: '',
    file: null
  });

  const handleFormChange = (event) => {
    const { name, value, files } = event.target;
    setFormData(prev => ({
      ...prev,
      [name]: files ? files[0] : value
    }));
  };

  const handleSubmit = async () => {
    if (!formData.recruiterId || !formData.file) {
      toast.error('Please fill all required fields');
      return;
    }

    const data = new FormData();
    data.append('recruiterId', formData.recruiterId);
    data.append('file', formData.file);

    try {
      console.log(data);
      await onSubmit(data);
      setFormData({ recruiterId: '', file: null });
    } catch (error) {
      console.error('Error in form submission:', error);
    }
  };

  return (
    <Modal
      className='bulk-upload-modal'
      open={show}
      onClose={onClose}
    >
      <Modal.Header>Add New Bulk Job</Modal.Header>
      <Modal.Content>
        <div className="bulk-upload-form">
          <div className="form-group">
            <label>Recruiter ID *</label>
            <InputBox
              name="recruiterId"
              value={formData.recruiterId}
              onChange={handleFormChange}
              placeholder="Enter Recruiter ID"
            />
          </div>
          
          <div className="form-group">
            <label>Upload File *</label>
            <input
              type="file"
              name="file"
              accept=".csv,.xlsx"
              onChange={handleFormChange}
              className="file-input"
            />
            <div className="file-help-text">
              Supported formats: CSV, XLSX
            </div>
          </div>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          skin="light"
          text="Cancel"
          clickButton={onClose}
        />
        <Button
          skin="dark"
          text="Submit"
          clickButton={handleSubmit}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default BulkJobUploadModal;